import clsx from "clsx";

export type SpinnerSize = "sm" | "md" | "lg";

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  sm: "h-4 w-4 border-2",
  md: "h-5 w-5 border-2",
  lg: "h-6 w-6 border-[2.5px]",
};

export function Spinner({ size = "sm", className, label = "Loading" }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} className={clsx("inline-flex", className)}>
      <span
        aria-hidden="true"
        className={clsx(
          "inline-block animate-spin rounded-full border-current border-r-transparent border-t-transparent",
          sizeMap[size],
        )}
      />
    </span>
  );
}
